import z from 'zod';

import { TagCategoryDtoSchema } from './TagCategoryDto';
import { TagCategoryDto } from './TagCategoryDto';

export type TagMappingDto = {
	id: string;
	iconSvgUrl: string | null;
	display: boolean;
	name: string;
	tagCategory: TagCategoryDto | null;
	source: string | null;
};

export const TagMappingDtoSchema: z.ZodType<TagMappingDto> = z.object({
	id: z.string(),
	iconSvgUrl: z.string().nullable(),
	display: z.boolean(),
	name: z.string(),
	tagCategory: z.lazy(() => TagCategoryDtoSchema).nullable(),
	source: z.string().nullable(),
});
